// Resolve the platform admin-server API URL relative to the current host
// so cross-app POSTs (e.g. PMA → admin-server /api/support/feedback)
// work across local dev (admin-server on :3100), the test environment
// (admin-test.goodstewardaba.com), and prod (admin.goodstewardaba.com)
// without per-env config plumbing.
//
// Mirrors homeAppUrl: caller passes its own subdomain prefix; the
// leading host fragment is swapped to 'admin' so both bare
// (pma.goodstewardaba.com → admin.goodstewardaba.com) and env-suffixed
// (pma-test.goodstewardaba.com → admin-test.goodstewardaba.com) hosts
// resolve correctly.
//
// Returns the ORIGIN only (no trailing slash, no /api prefix). Callers
// append the full path themselves — e.g.
// `${adminServerUrl('pma')}/api/support/feedback`.
export function adminServerUrl(fromPrefix: string): string {
    if (typeof window === 'undefined') return '';
    const { protocol, hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return `${protocol}//${hostname}:3100`;
    }
    const swapped = hostname.startsWith(fromPrefix)
        ? hostname.replace(new RegExp(`^${fromPrefix}`), 'admin')
        : `admin.${hostname}`;
    return `${protocol}//${swapped}`;
}
